"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _RemoteBackend = require("./RemoteBackend");

var _RemoteBackend2 = _interopRequireDefault(_RemoteBackend);

var _Language = require("./Language");

var _Language2 = _interopRequireDefault(_Language);

var _Phrase = require("./Phrase");

var _Phrase2 = _interopRequireDefault(_Phrase);

var _Dialog = require("./Dialog");

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Auth = require("./Auth");

var _Auth2 = _interopRequireDefault(_Auth);

var _Settings = require("./Settings");

var _Settings2 = _interopRequireDefault(_Settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collection = function Collection(api, namespace, objectIds) {
  var _this = this;

  (0, _classCallCheck3.default)(this, Collection);

  this.getObject = function (id) {
    return _this.api.store.objects[_this.namespace][id];
  };

  this.getObjects = function () {
    return _this.objectIds.map(function (id) {
      return _this.api.store.objects[_this.namespace][id];
    }).filter(function (object) {
      return object;
    });
  };

  Object.assign(this, { api: api, namespace: namespace, objectIds: objectIds });
};

var API = function () {
  function API(backend) {
    var _this2 = this;

    var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { objects: {}, collections: {} };
    (0, _classCallCheck3.default)(this, API);

    this.getBaseUrl = function () {
      return _this2.backend.getBaseUrl();
    };

    this.setBaseUrl = function (baseUrl) {
      return _this2.backend.setBaseUrl(baseUrl);
    };

    this.getInstance = function () {
      return _this2.backend.getInstance();
    };

    this.setInstance = function (baseUrl) {
      return _this2.backend.setInstance(baseUrl);
    };

    this.fetchJson = function (endpoint, query, method, body) {
      return _this2.backend.fetchJson(endpoint, query, method, body);
    };

    this.getCollection = function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(ObjectType, endpoint) {
        var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var useCache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        var cachedCollection, filteredObjects, result, existingCollection, existingObjects, objects, collection;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cachedCollection = useCache ? _this2.store.collections[endpoint] && _this2.store.collections[endpoint].getObjects() : false;
                filteredObjects = cachedCollection && cachedCollection.filter(function (item) {
                  return Object.keys(query).every(function (key) {
                    return item[key] === query[key];
                  });
                });

                if (!filteredObjects) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", filteredObjects);

              case 4:
                if (endpoint.indexOf("cursor") > -1 && _this2.store.cursor) {
                  endpoint += _this2.store.cursor;
                }
                /*var result =
                  (await this.backend.fetchJson(endpoint, query, "get", {})) || [];
                // const result = r.List ? r.List : [];
                // this.store.cursor = r.Cursor  
                if(endpoint.indexOf("cursor") > -1){
                  this.store.cursor = result.Cursor;
                  result = result.List ? result.List : [];
                
                  if(result.length === 0){
                    await this.backend.fetchJson("phrases?cursor="+this.store.cursor, {}, "delete", {})
                    this.store.cursor = ""
                  }
                }*/
                result = [];
                _context.next = 8;
                return _this2.backend.fetchJson(endpoint, query, "get", {});

              case 8:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 11;
                  break;
                }

                _context.t0 = [];

              case 11:
                result = _context.t0;
                existingCollection = null;
                //this.store.collections[endpoint];

                existingObjects = existingCollection ? existingCollection.getObjects() : [];
                objects = existingObjects.reduce(function (acl, curr) {
                  return (0, _defineProperty3.default)({}, curr.id, curr);
                }, {});


                result.forEach(function (object) {
                  objects[object.id] = new ObjectType(_this2, object);
                });

                _this2.store.objects[ObjectType._namespace] = Object.assign({}, _this2.store.objects[ObjectType._namespace], objects);

                collection = new Collection(_this2, ObjectType._namespace, Object.keys(objects).map(function (object) {
                  return object;
                }));


                _this2.store.collections[endpoint] = collection;
                return _context.abrupt("return", collection.getObjects());

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x4, _x5) {
        return _ref.apply(this, arguments);
      };
    }();

    this.getObject = function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(ObjectType, endpoint, id) {
        var useCache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        var cacheId, formattedEndpoint, inStoreObjects, result;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cacheId = id || endpoint.split("/").pop();
                formattedEndpoint = id ? endpoint + "/" + id : endpoint;
                inStoreObjects = _this2.store.objects[ObjectType._namespace] || [];

                if (!(inStoreObjects[cacheId] && useCache)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", inStoreObjects[cacheId]);

              case 5:
                _context2.next = 7;
                return _this2.backend.fetchJson(formattedEndpoint, {}, "get", {});

              case 7:
                result = _context2.sent;
                return _context2.abrupt("return", _this2.addItemToStore(ObjectType, endpoint, result));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x7, _x8, _x9) {
        return _ref3.apply(this, arguments);
      };
    }();

    this.postObject = function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(ObjectType, endpoint) {
        var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        var result, mashedObject, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, field;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.backend.fetchJson(endpoint, query, "post", data);

              case 2:
                result = _context3.sent;
                mashedObject = {};
                // eslint-disable-next-line no-undef

                if (!(data instanceof FormData)) {
                  _context3.next = 26;
                  break;
                }

                // eslint-disable-next-line no-restricted-syntax
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 8;
                for (_iterator = data.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  field = _step.value;

                  Object.assign(mashedObject, {}, (0, _defineProperty3.default)({}, field[0], field[1]));
                }
                _context3.next = 16;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 16:
                _context3.prev = 16;
                _context3.prev = 17;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 19:
                _context3.prev = 19;

                if (!_didIteratorError) {
                  _context3.next = 22;
                  break;
                }

                throw _iteratorError;

              case 22:
                return _context3.finish(19);

              case 23:
                return _context3.finish(16);

              case 24:
                _context3.next = 27;
                break;

              case 26:
                Object.assign(mashedObject, data);

              case 27:
                return _context3.abrupt("return", _this2.addItemToStore(ObjectType, endpoint, Object.assign({}, mashedObject, result)));

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[8, 12, 16, 24], [17,, 19, 23]]);
      }));

      return function (_x12, _x13) {
        return _ref4.apply(this, arguments);
      };
    }();

    this.patchObject = function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(ObjectType, endpoint, id, data) {
        var result;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this2.backend.fetchJson(endpoint + "/" + id, {}, "patch", data);

              case 2:
                result = _context4.sent;

                Object.assign(_this2.store.objects[ObjectType._namespace][id], result);
                return _context4.abrupt("return", result);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function (_x14, _x15, _x16, _x17) {
        return _ref5.apply(this, arguments);
      };
    }();

    this.putObject = function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(ObjectType, endpoint, id, data) {
        var result;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this2.backend.fetchJson(endpoint + "/" + id, {}, "put", data);

              case 2:
                result = _context5.sent;

                Object.assign(_this2.store.objects[ObjectType._namespace][id], result);
                return _context5.abrupt("return", result);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this2);
      }));

      return function (_x18, _x19, _x20, _x21) {
        return _ref6.apply(this, arguments);
      };
    }();

    this.deleteObject = function () {
      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(ObjectType, endpoint, id) {
        var deleteFromCollectionOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this2.backend.fetchJson(endpoint + "/" + id, {}, "delete", {});

              case 2:
                if (_this2.store.collections[endpoint]) {
                  _this2.store.collections[endpoint].objectIds = _this2.store.collections[endpoint].objectIds.filter(function (objectId) {
                    return objectId !== id;
                  });
                }
                if (!deleteFromCollectionOnly) {
                  delete _this2.store.objects[ObjectType._namespace][id];
                }
                return _context6.abrupt("return", true);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this2);
      }));

      return function (_x23, _x24, _x25) {
        return _ref7.apply(this, arguments);
      };
    }();

    this.addItemToStore = function (ObjectType, endpoint, item) {
      if (Object.getOwnPropertyNames(item).length === 0) {
        return null;
      }

      var _ref8 = _this2.store.collections[endpoint] || {},
          _ref8$objectIds = _ref8.objectIds,
          objectIds = _ref8$objectIds === undefined ? [] : _ref8$objectIds;

      var objects = _this2.store.objects[ObjectType._namespace] || {};
      var objectId = item.id || endpoint.split("/").pop();
      objectIds.push(objectId);
      var object = new ObjectType(_this2, item);
      _this2.store.objects[ObjectType._namespace] = Object.assign(objects, (0, _defineProperty3.default)({}, objectId, object));
      var collection = new Collection(_this2, ObjectType._namespace, objectIds);
      _this2.store.collections[endpoint] = collection;
      return object;
    };

    this.signin = function (username, password) {
      return _Auth2.default.signin(_this2, { username: username, password: password });
    };

    this.signout = function () {
      _this2.clearCache();
      _Auth2.default.signout(_this2);
    };

    this.getLanguages = function () {
      return _Language2.default.getLanguages(_this2);
    };

    this.addNewLanguage = function (data) {
      return _Language2.default.addNewLanguage(_this2, data);
    };

    this.updateLanguage = function (id, data) {
      return _Language2.default.updateLanguage(_this2, id, data);
    };

    this.deleteLanguage = function (id) {
      return _Language2.default.deleteLanguage(_this2, id);
    };

    this.getPhrases = function () {
      return _Phrase2.default.getPhrases(_this2);
    };

    this.getPhrasesChunk = function (chunk) {
      return _Phrase2.default.getPhrasesChunk(_this2, chunk);
    };

    this.getPhrase = function (id) {
      return _Phrase2.default.getPhrase(_this2, id);
    };

    this.addNewPhrase = function (data) {
      return _Phrase2.default.addNewPhrase(_this2, data);
    };

    this.updatePhrase = function (id, data) {
      return _Phrase2.default.updatePhrase(_this2, id, data);
    };

    this.deletePhrase = function (id) {
      return _Phrase2.default.deletePhrase(_this2, id);
    };

    this.getDialogs = function () {
      return _Dialog2.default.getDialogs(_this2);
    };

    this.getDialog = function (id) {
      return _Dialog2.default.getDialog(_this2, id);
    };

    this.createDialog = function (data) {
      return _Dialog2.default.createDialog(_this2, data);
    };

    this.updateDialog = function (id, data) {
      return _Dialog2.default.updateDialog(_this2, id, data);
    };

    this.deleteDialog = function (id) {
      return _Dialog2.default.deleteDialog(_this2, id);
    };

    this.getInstances = function () {
      return _Dialog2.default.getInstances(_this2);
    };

    this.getLatestVersion = function () {
      return _Settings2.default.getLatestVersion(_this2, _this2.backend.instance);
    };

    this.getDatapackage = function (version) {
      return _Settings2.default.getDatapackage(_this2, _this2.backend.instance, version);
    };

    this.createVersion = function () {
      return _Settings2.default.createVersion(_this2, _this2.backend.instance);
    };

    Object.assign(this, { backend: backend, store: store });
  }

  (0, _createClass3.default)(API, [{
    key: "clearCache",
    value: function clearCache() {
      this.store = { objects: {}, collections: {} };
    }
  }]);
  return API;
}();

var api = new API(new _RemoteBackend2.default());
exports.default = api;


//////////////////
// WEBPACK FOOTER
// ../sdk/lib/HelenAPI.js
// module id = 271
// module chunks = 0